export const I18n = {
	'en': {
        pointsListTitle: 'Trader points list',
        searchPlaceholder: 'Search by name',
        add: 'Add point',
		sureMember: 'A you sure to delete a member ?',
		delete: 'Delete',
		cancel: 'Cancel',
		sure: 'Are you sure ?',
		tt_changeData: 'Traders point - Edit data',
		tt_addPoint: 'Add traders point',
		memberAdd: 'Members - Add',
		memberRemove: 'Members - delete',

	},
	'ru': {
        pointsListTitle: 'Список торговых точек',
        searchPlaceholder: 'Поиск по названию',
        add: 'Добавить',
		sureMember: 'Вы уверены в удалении сотрудника ?',
		delete: 'Удалить',
		cancel: 'Отмена',
		sure: 'Вы уверены ?',
		tt_changeData: 'Торговая точка - Изменить данные',
		tt_addPoint: 'Добавить торговую точку',
		memberAdd: 'Сотрудники - добавить',
		memberRemove: 'Сотрудники - удалить',

	},
	'sk': {
		pointsListTitle: 'Zoznam obchodník body',
		searchPlaceholder: 'Vyhľadávanie podľa mena',
		add: 'Pridať',
		sureMember: 'Naozaj chcete odstrániť člena?',
		delete: 'Vymazať',
		cancel: 'Zrušiť',
		sure: 'Si si istý ?',
		tt_changeData: 'Obchodníci poukazujú - Upraviť údaje',
		tt_addPoint: 'Pridať obchodníci poukazujú',
		memberAdd: 'Členovia - Pridať',
		memberRemove: 'Členovia - zmazať',

	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/stores/index.js